import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DsCardComponent, DsIconComponent } from '@customdesignsystem';
import { PiInfoAlertComponent } from '../pi-info-alert/pi-info-alert.component';
import { PiRequirementItemComponent } from '../pi-requirement-item/pi-requirement-item.component';
import { GtmService } from '@services/gtm/gtm.service';

/**
 * Important information card — requisitos del paso 0 (Figma).
 */
@Component({
  selector: 'app-pi-requisitos-card',
  standalone: true,
  imports: [
    CommonModule,
    DsCardComponent,
    DsIconComponent,
    PiRequirementItemComponent,
    PiInfoAlertComponent,
  ],
  templateUrl: './pi-requisitos-card.component.html',
  styleUrls: ['./pi-requisitos-card.component.scss'],
})
export class PiRequisitosCardComponent {

  constructor(private readonly gtmService: GtmService) { }
  abrirRegistroCivil(event: Event): void {
    this.gtmService.trackClick('link_registro_civil', 'www.registrocivil.cl', 'link_externo', 'https://www.registrocivil.cl/');
    event.preventDefault();
    window.open('https://www.registrocivil.cl/', '_blank', 'noopener,noreferrer');
  }
}
